import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { registerSW } from 'virtual:pwa-register';

createRoot(document.getElementById('root')!).render(<App />);

// Register PWA service worker with auto-update
try {
  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      console.log('[PWA] New version available, reloading...');
      updateSW(true);
    },
    onOfflineReady() {
      console.log('[PWA] Application is offline ready.');
    },
    onRegistered(registration) {
      console.log('[PWA] Service worker registered successfully:', registration?.scope);
    },
    onRegisterError(error) {
      console.warn('[PWA] Service worker registration error:', error);
    }
  });
} catch {
  // Graceful fallback for non-PWA environments
  if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch((err) => {
        console.warn('Fallback SW registration failed:', err);
      });
    });
  }
}

